module.exports = __webpack_public_path__ + "static/img/flag-ger.5bda5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-ger.png
// module id = m8hs
// module chunks = 1